import { BLOCK_TYPE } from './CONSTANTS';

const shouldShowInsertButton = (selection, block) => (
    selection.getHasFocus()
    && selection.isCollapsed()
    && block.getText().trim() === ''
    && (block.type.includes(BLOCK_TYPE.UNSTYLED) || block.type.includes('header-'))
);

export default shouldShowInsertButton;
